// extracted by mini-css-extract-plugin
export var actions = "_ql-5";
export var assistantBubble = "_ql-3";
export var assistantRow = "_ql-6";
export var bubble = "_ql-0";
export var humanAvatar = "_ql-4";
export var inlineToolCard = "_ql-1";
export var userBubble = "_ql-2";